module.exports = __webpack_public_path__ + "static/media/1.605e5e25.jpg";